"use strict";import{css as a}from"@spectrum-web-components/base";const o=a`
#switch:before{transition:background var(--spectrum-global-animation-duration-100,.13s) ease-in-out,border var(--spectrum-global-animation-duration-100,.13s) ease-in-out,box-shadow var(--spectrum-global-animation-duration-100,.13s) ease-in-out}
`;export default o;
//# sourceMappingURL=switch-legacy.css.js.map
